import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suggestion-shows',
  templateUrl: './suggestion-shows.component.html',
  styleUrls: ['./suggestion-shows.component.css']
})
export class SuggestionShowsComponent implements OnInit {
  constructor() { }
  ngOnInit(): void {}

}
